<template>
    <el-card
            class="musteri-guncelle-form"
            v-loading="loading">
        <template slot="header">
            <el-row type="flex" justify="start">
                <div>
                    <el-button icon="el-icon-back" type="text" size="small" @click="golist"></el-button>
                    Müşteri Güncelle
                </div>
            </el-row>
        </template>

        <el-form
                ref="musteriForm"
                :model="form"
                :rules="rules"
                label-position="left"
                label-width="180px"
                align="left">
            <el-form-item prop="sirket_id" label="Fatura Bilgisi Seçiniz">
                <el-select v-model="form.sirket_id" filterable placeholder="Fatura Bilgisi seciniz">
                    <el-option v-for="s in sirkets" :value="s.id" :label="s.adi" :key="`${s.id}-sirket`"/>
                </el-select>
                <el-button icon="el-icon-plus" @click="sirketFormVisible = true" style="margin-left: 10px"></el-button>
            </el-form-item>

            <el-divider/>

            <el-form-item prop="durumu" label="Müşteri Durumu Seçiniz">
                <el-radio-group v-model="form.durumu">
                    <el-radio-button :label="null">Kiralık</el-radio-button>
                    <el-radio-button label="demo">Demo</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item v-if="form.durumu" prop="demo_gun_sayisi" label="Demo Gün Sayısı Seçiniz">
                <el-radio-group v-model="form.demo_gun_sayisi">
                    <el-radio-button
                            :label="gun.label"
                            v-for="gun in demoGunleri"
                            :key="gun.value">{{gun.title}}</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-divider/>
        </el-form>

        <el-table :data="list" empty-text="Henüz makina eklenmedi!">

            <el-table-column type="expand" width="50">
                <template slot-scope="{ row }">
                    <p><b>Koku ml:</b> {{row.koku_ml}}</p>
                    <p><b>Yoğunluk:</b> {{row.yogunluk}}</p>
                    <p><b>Tutar:</b> {{row.tutar}}</p>
                    <p><b>Not:</b> {{row.not}}</p>
                </template>
            </el-table-column>

            <el-table-column type="index"/>
            <el-table-column prop="makina_adi" label="Makina"/>
            <el-table-column prop="koku_adi" label="Koku"/>
            <el-table-column prop="baslangic_zamani" label="Başlangıç"/>

            <el-table-column width="150">
                <el-button slot="header" icon="el-icon-plus" size="medium" @click="mmVisible = true">Yeni
                </el-button>
                <template slot-scope="{ row }">
                    <el-button
                            icon="el-icon-refresh"
                            size="medium"
                            @click="openUpdate(row)"/>
                    <el-popconfirm
                            v-if="isAdmin"
                            title="Silmek istediginize emin misiniz?"
                            confirmButtonText="Evet"
                            cancelButtonText="iptal"
                            @onConfirm="remove(row)"
                    >
                        <el-button
                                slot="reference"
                                icon="el-icon-delete"
                                type="danger"
                                size="medium"/>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <musteri-makina v-if="false" @add="add" @close="mmVisible = false"/>

        <el-row class="musteri-guncelle-form-footer">
            <el-button
                    type="success"
                    size="large"
                    :disabled="isTheSame"
                    icon="el-icon-folder-add"
                    @click="submit">Güncelle
            </el-button>
        </el-row>

        <el-dialog title="Yeni Makina Ekle" :visible.sync="mmVisible" width="100%">
            <musteri-makina @add="add" @close="mmVisible = false"/>
        </el-dialog>

        <el-dialog title="Makina Güncelle" :visible.sync="mmUpdateVisible" width="100%">
            <musteri-makina
                    v-if="mmUpdateVisible"
                    v-loading="process.musteri"
                    :update-id="updateId"
                    @update="updateMakina"
                    @close="mmUpdateVisible = false"/>
        </el-dialog>

        <el-dialog title="Fatura Bilgisi Ekle" :visible.sync="sirketFormVisible" width="100%">
            <sirket-form v-if="sirketFormVisible" :visible="sirketFormVisible" @success="fetchSirket"/>
        </el-dialog>
    </el-card>
</template>

<script>
    import Vuex from 'vuex';
    import Formatter from '@/mixins/Formatter.js';
    import MusteriMakina from '@/components/MusteriMakinaForm.vue'
    import SirketForm from './SirketForm.vue'

    export default {
        name: 'musteri-guncelle-form',
        components: {MusteriMakina, SirketForm},
        mixins: [Formatter],
        data() {
            return {
                sirketFormVisible: false,
                mmVisible: false,
                updateId: null,
                mmUpdateVisible: false,
                process: {
                    musteri: false,
                    makina: false,
                    sirket: false,
                    koku: false,
                    loading: false,
                },
                makinalar: [],
                form: {
                    sirket_id: null,
                    durumu: null,
                    demo_gun_sayisi: 3,
                },
                rules: {
                    sirket_id: [{required: true, message: 'Fatura Bilgisi seçiniz', trigger: 'change'}],
                },
                makinaList: [],
                sirketList: [],
                kokuList: [],
                demoGunleri:  [
                    { label: 3, title: '3 Günlük' },
                    { label: 5, title: '5 Günlük' },
                    { label: 7, title: '7 Günlük' },
                ],
                originalMusteri: {
                    id: null,
                    sirket_id: null,
                    sirket_adi: null,
                    durumu: null,
                    demo_gun_sayisi: 3,
                },
            };
        },
        computed: {
            ...Vuex.mapGetters(['isAdmin']),
            id() {
                return this.$route.params.id;
            },
            loading() {
                const { makina, koku, sirket, musteri } = this.process;
                return makina || koku || sirket || musteri;
            },
            isTheSame() {
                const { sirket_id, sirket_adi, durumu, demo_gun_sayisi } = this.originalMusteri;
                return this.form.sirket_id === sirket_id
                    && this.form.sirket_adi === sirket_adi
                    && this.form.durumu === durumu
                    && this.form.demo_gun_sayisi === demo_gun_sayisi;
            },
            kokuMapping() {
                return this.kokuList.reduce((res, d) => {
                    res[d.id] = d.adi;
                    return res;
                }, {});
            },
            makinaMapping() {
                return this.makinaList.reduce((res, d) => {
                    res[d.id] = d.adi;
                    return res;
                }, {});
            },
            list() {
                return this.makinalar
                    .map((d) => {
                        let a = Object.assign({}, d);
                        a.makina_adi = this.makinaMapping[d.makina_id];
                        a.koku_adi = this.kokuMapping[d.koku_id];
                        return a;
                    });
            },
            sirkets() {
                return this.sirketList.slice()
                    .sort((a, b) => {
                        return a['adi'] - b['adi'];
                    });
            }
        },
        methods: {
            test() {
                alert('test')
            },
            add(makina) {
                const mm = Object.assign({}, makina);
                mm.musteri_id = this.id;

                this.addMakina(mm);
            },
            addMakina(makina) {
                this.process.musteri = true;
                this.$requests
                    .MusteriMakina
                    .createMusteriMakina(makina)
                    .then(() => {
                        this.mmVisible = false;
                        this.fetchMusteriDetail();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.musteri = false;
                    });
            },
            openUpdate(makina) {
                this.updateId = makina.id;
                this.mmUpdateVisible = true;
            },
            updateMakina(makina) {
                const mm = Object.assign({}, makina);
                mm.musteri_id = this.id;

                this.process.musteri = true;
                this.$requests
                    .MusteriMakina
                    .updateMusteriMakina(this.updateId, mm)
                    .then(() => {
                        this.fetchMusteriDetail();
                        this.updateId = null;
                        this.mmUpdateVisible = false;
                        this.$message.success('Makina başarıyla güncellendi!')
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.musteri = false;
                    });
            },
            remove(makina) {
                this.$confirm(`Bu makina kaldırılacaktır, bu işlemi yapmak istedinize emin misiniz?`, 'Uyarı')
                    .then(() => {
                        this.removeMakina(makina.id);
                    })
                    .catch(() => {})
            },
            removeMakina(id) {
                this.process.musteri = true;
                this.$requests
                    .MusteriMakina
                    .deleteMusteriMakina(id)
                    .then(() => {
                        this.fetchMusteriDetail();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.musteri = false;
                    });
            },
            golist() {
                this.$router.go(-1);
            },
            submit() {
                this.$refs.musteriForm.validate((valid) => {
                    if (valid) {
                        this.update();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            update() {
                let musteri = Object.assign({}, this.form);
                delete musteri.sirket_adi;

                this.process.musteri = true;
                this.$requests.Musteri.updateMusteri(musteri.id, musteri)
                    .then(() => {
                        this.$refs.musteriForm.resetFields();
                        this.$message.success('Musteri kaydi basariyla guncellendi!');
                        this.golist();
                    })
                    .catch((e) => {
                        console.error('error updating musteri', e);
                    })
                    .then(() => {
                        this.process.musteri = false;
                    });
            },
            fetchMakina() {
                this.process.makina = true;
                this.$requests.Makina.getMakina(this.form)
                    .then((data) => {
                        this.makinaList = data;
                    })
                    .catch((e) => {
                        console.error('error fetching makina list', e);
                    })
                    .then(() => {
                        this.process.makina = false;
                    });
            },
            fetchSirket() {
                this.sirketFormVisible = false;
                this.process.sirket = true;
                this.$requests.Sirket.getSirket()
                    .then((data) => {
                        this.sirketList = data;
                    })
                    .catch((e) => {
                        console.error('error fetching sirket list', e);
                    })
                    .then(() => {
                        this.process.sirket = false;
                    });
            },
            fetchMusteriDetail() {
                if (!this.id) {
                    return;
                }
                this.sirketFormVisible = false;
                this.process.musteri = true;
                this.$requests.Musteri.getMusteriDetail(this.id)
                    .then((d) => {
                        this.musteri = d;
                        this.makinalar = d.makinalar;

                        this.form = {
                            id: d.id,
                            sirket_id: d.sirket_id,
                            sirket_adi: d.sirket_adi,
                            durumu: d.durumu,
                            demo_gun_sayisi: d.demo_gun_sayisi,
                        };
                        this.originalMusteri = Object.assign({}, this.form);
                    })
                    .catch((e) => {
                        console.error('error fetching sirket list', e);
                    })
                    .then(() => {
                        this.process.musteri = false;
                    });
            },
            fetchKoku() {
                this.process.koku = true;
                this.$requests.Koku.getKoku()
                    .then((data) => {
                        this.kokuList = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.koku = false;
                    });
            },
        },
        mounted() {
            if (!this.id) {
                this.$router.go(-1);
            }
            this.fetchKoku();
            this.fetchMakina();
            this.fetchSirket();
            this.fetchSirket();

            this.fetchMusteriDetail();
        },
        watch: {
            'form.durumu'() {
                if (this.form.durumu) {
                    this.form.demo_gun_sayisi = this.originalMusteri.demo_gun_sayisi;
                } else {
                    this.form.demo_gun_sayisi = null;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .musteri-guncelle-form {
        .musteri-guncelle-form-footer {
            margin: 20px 0;
        }

        .el-divider {
            margin: 0 0 25px 0;
            visibility: hidden;
        }
    }
</style>
